module.exports = __webpack_public_path__ + "static/media/cover1.cc52aad4.png";